import React, { useEffect, useState } from 'react';

// Set REACT_APP_API_URL=https://api.eazyworldehsengineering.com in frontend/.env.production
const API = process.env.REACT_APP_API_URL || 'https://apiwebsite.eazyworldehsengineering.com';

// Static fallback images already in public/images/
const STATIC = {
  home:     ['/images/home.jpeg', ...Array.from({ length: 13 }, (_, i) => `/images/home${i + 1}.jpeg`)],
  about:    Array.from({ length: 13 }, (_, i) => `/images/About${i + 1}.jpeg`),
  services: ['/images/services.jpeg', ...Array.from({ length: 11 }, (_, i) => `/images/services${i + 1}.jpeg`)],
  training: Array.from({ length: 12 }, (_, i) => `/images/train${i + 1}.jpeg`),
  clients:  [],
  products: [],
  contact:  [],
};

export default function ImageSlider({ page }) {
  const [images, setImages] = useState([]);

  useEffect(() => {
    fetch(`${API}/api/images/${page}`)
      .then(r => r.json())
      .then(urls => {
        if (urls.length > 0) {
          setImages(urls.map(u => `${API}${u}`));
        } else {
          setImages(STATIC[page] || []);
        }
      })
      .catch(() => setImages(STATIC[page] || []));
  }, [page]);

  if (!images.length) return null;

  const doubled = [...images, ...images];

  return (
    <div className="relative overflow-hidden w-full">
      <div className="absolute left-0 top-0 bottom-0 w-20 bg-gradient-to-r from-white to-transparent z-10 pointer-events-none" />
      <div className="absolute right-0 top-0 bottom-0 w-20 bg-gradient-to-l from-white to-transparent z-10 pointer-events-none" />

      <div className="flex animate-infinite-scroll gap-3 w-max">
        {doubled.map((src, i) => (
          <div key={i} className="shrink-0 w-64 h-44 rounded-xl overflow-hidden border border-gray-200 hover:border-orange-300 transition-colors duration-300 shadow-sm">
            <img src={src} alt="" className="w-full h-full object-cover" loading="lazy" />
          </div>
        ))}
      </div>
    </div>
  );
}
